import {
  INVALID_EMAIL_DOMAIN_ERROR,
  isValidEmailDomain,
} from "@p0security/shared/configuration/utils";

export const validateWorkEmailDomain = async (_: any, value: string) => {
  if (!value) {
    throw new Error("Please enter an email");
  }

  if (!isValidEmailDomain(value)) {
    throw new Error(INVALID_EMAIL_DOMAIN_ERROR);
  }
};
